<template lang="pug">
  div
    div(style='width:500px; margin-left: auto; margin-right: auto;')
      h4(style='text-align: center; margin-top:10px') Speicherung als PDF
      v-switch(label='Konzept einblenden' v-model='concept' inset class='toggle')
      v-switch(label='Beiträge anzeigen' v-model='charges' inset class='toggle')
    v-col.pb-0(cols="12"): v-btn(cols="6" block color="primary" @click="onExport" :loading="loading") Exportieren
      template(v-slot:loader)
        v-progress-circular(indeterminate)
</template>

<script>
import {
  Vue,
  Prop,
  Component
} from 'vue-property-decorator'
import urls from '../../../../router/urls'
import { downloadBlob, getFileNameFromHeader } from '../../../../utils/download'

@Component({})

export default class Export extends Vue {
  @Prop({ type: Object | null, default: null }) currentLight
  @Prop({ type: [ Number, String ], default: 0 }) lightId

  concept = true
  charges = true
  loading = false
  onExport () {
    const params = {
      id: parseInt(this.lightId),
      with_concept: this.concept,
      with_sums: this.charges
    }
    this.loading = true
    this.$axios
      .fetchFile(urls.ConsultationLightExport(), params)
      .then(async (res) => {
        const blob = await res.blob()
        return {
          blob,
          headers: res.headers
        }
      })
      .then((res) => {
        downloadBlob(res.blob, getFileNameFromHeader(res.headers, res.headers.get('Content-Disposition')))
      })
      .catch((err) => {
        this.$toast.error(err.message, 'Fehler')
      })
      .finally(() => {
        this.loading = false
      })
  }
}

</script>
<style>
.toggle>.v-input--switch--inset .v-input--switch__track, .v-input--switch--inset .v-input--selection-controls__input {
    order: 2;
}
</style>
